import React from "react";
import { ExpressionView } from "../ExpressionView";
import { expressionStoryData } from "../Testing/ExpressionData";
import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { StringIndexOfExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIndexOfExpression";
import { StringListInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListInExpression";
import { StringListContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListContainsExpression";
import { StringStartWithExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringStartWithExpression";
import { StringTrimExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringTrimExpression";
import { StringUppercaseExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringUppercaseExpression";
import { StringLowercaseExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringLowercaseExpression";
import { StringNotContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringNotContainsExpression";
import { StringListNotContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotContainsExpression";
import { StringListNotAllInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotAllInExpression";
import { StringListAllInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListAllInExpression";
import { StringProperExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringProperExpression";
import { StringLengthExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";
import { StringCombineExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringCombineExpression";
import { StringListNotInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotInExpression";
import { StringContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { StringEqualExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringEqualExpression";
import { StringEndWithExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringEndWithExpression";
import { StringListGetStringByIndexExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListGetStringByIndexExpression";
import { StringIsNotEmptyExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";
import { StringListCombineExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListCombineExpression";
import { StringIsEmptyExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsEmptyExpression";
import { StringIsValidEmailExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsValidEmailExpression";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const ExpressionViewStringStories = [
    new StoryNode(
        () => {
            let expression = new StringListCombineExpression();
            expression.value1.variableName = "stringList";
            expression.value2.value = ["1", "2"];
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List Combine",
    ),
    new StoryNode(
        () => {
            let expression = new StringCombineExpression();
            expression.value1.value = "a";
            expression.value2.value = "b";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Combine",
    ),
    new StoryNode(
        () => {
            let expression = new StringContainsExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Contains",
    ),
    new StoryNode(
        () => {
            let expression = new StringEqualExpression();
            expression.value1.value = "abcd";
            expression.value2.value = "abcd";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Equals",
    ),
    new StoryNode(
        () => {
            let expression = new StringEndWithExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Ends With",
    ),
    new StoryNode(
        () => {
            let expression = new StringIndexOfExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Index Of",
    ),
    new StoryNode(
        () => {
            let expression = new StringIsEmptyExpression();
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Is Empty",
    ),
    new StoryNode(
        () => {
            let expression = new StringIsNotEmptyExpression();
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Is Not Empty",
    ),
    new StoryNode(
        () => {
            let expression = new StringIsValidEmailExpression();
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Is Valid Email",
    ),
    new StoryNode(
        () => {
            let expression = new StringLengthExpression();
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Length",
    ),
    new StoryNode(
        () => {
            let expression = new StringListAllInExpression();
            expression.value1.value = ["1", "2"];
            expression.value2.value = ["3", "4"];
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List All In",
    ),
    new StoryNode(
        () => {
            let expression = new StringListContainsExpression();
            expression.value1.value = ["1", "2"];
            expression.value2.value = "1";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List Contains",
    ),
    new StoryNode(
        () => {
            let expression = new StringListGetStringByIndexExpression();
            expression.value1.value = 2;
            expression.value2.variableName = "stringList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Get String By Index",
    ),
    new StoryNode(
        () => {
            let expression = new StringListInExpression();
            expression.value1.value = "aaa";
            expression.value2.variableName = "stringList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List In",
    ),
    new StoryNode(
        () => {
            let expression = new StringListNotAllInExpression();
            expression.value1.value = ["aaa", "bbb"];
            expression.value2.variableName = "stringList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List Not All In",
    ),
    new StoryNode(
        () => {
            let expression = new StringListNotContainsExpression();
            expression.value1.value = ["aaa", "bbb"];
            expression.value2.variableName = "stringList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List Not Contains",
    ),
    new StoryNode(
        () => {
            let expression = new StringListNotInExpression();
            expression.value1.variableName = "stringList";
            expression.value2.value = ["aaa", "bbb"];
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "List Not In",
    ),
    new StoryNode(
        () => {
            let expression = new StringLowercaseExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Lower Case",
    ),
    new StoryNode(
        () => {
            let expression = new StringNotContainsExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Not Contains",
    ),
    new StoryNode(
        () => {
            let expression = new StringProperExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Proper Case",
    ),
    new StoryNode(
        () => {
            let expression = new StringStartWithExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "StartsWith",
    ),
    new StoryNode(
        () => {
            let expression = new StringTrimExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Trim",
    ),
    new StoryNode(
        () => {
            let expression = new StringUppercaseExpression();
            expression.value1.variableName = "stringVal";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "String",
        "Upper Case",
    ),
];
